export default __webpack_public_path__ + "static/media/Jahangir-mahal-palace-at-blue-sky-in-India.4090d628.jpg";